import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { toObjectMap } from "@@/utilities/dictionary";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { idZodSchema } from "../id";

const alfredItemStatusTypes = ["ACTIVE", "DRAFT", "PAUSED", "DANCING"] as const; // hahahaha, haha, hihi, hahahahahahaha,
type AlfredItemStatusType = (typeof alfredItemStatusTypes)[number];
const alfredItemStatusTypeMap = toObjectMap<AlfredItemStatusType>([
    ...alfredItemStatusTypes,
]);

type AlfredItemStatus = {
    _id: string;
    _created: IsoAndUnixTimestamp;
    type: AlfredItemStatusType; // todo: maybe change name to value, to prevent status.status
    status?: AlfredItemStatusType; // TODO! REMOVE, DEPRECATED, NEED TO RESEED DB FIRST THOUGH
};

const alfredItemStatusFactory = (params: {
    type: AlfredItemStatusType;
}): AlfredItemStatus => {
    return {
        _id: generateId({ prefix: "alfreditemstatus__" }),
        _created: nowIsoAndUnix(),
        ...params,
    };
};

const alfredItemStatusZodSchema: z.ZodSchema<AlfredItemStatus> = z.object({
    _id: idZodSchema,
    _created: isoAndUnixZodSchema,
    type: z.enum(alfredItemStatusTypes),
    status: z.enum(alfredItemStatusTypes).optional(),
});

const defaultAlfredItemStatus = alfredItemStatusFactory({
    type: "ACTIVE",
});

export {
    alfredItemStatusFactory,
    alfredItemStatusTypeMap,
    alfredItemStatusTypes,
    alfredItemStatusZodSchema,
    defaultAlfredItemStatus,
};
export type { AlfredItemStatus, AlfredItemStatusType };
